import { Space, theme, Typography } from "antd";
import { AutoCenter, Button } from "antd-mobile";
import { FC, useCallback, useContext, useState } from "react";
import { useSelector } from "react-redux";
import { styled } from "styled-components";
import GraiaIcon from "../../assets/GraiaIcon";
import AppBaseLayout from "../../components/layouts/AppBaseLayout";
import CenterContent from "../../components/layouts/CenterContent";
import { UserManagerContext } from "../../providers/auth/UserManagerProvider";
import { useLazyGetAgentStateQuery, useLoginMutation } from "../../redux/apis/blenderApi";
import { selectAuthInfo } from "../../redux/slices/authSlice";

const { Title } = Typography;

const LoginPage: FC = () => {
  const { token } = theme.useToken();

  const userManager = useContext(UserManagerContext);

  const { user } = useSelector(selectAuthInfo);

  const [loginToBlender] = useLoginMutation();
  const [getAgentState] = useLazyGetAgentStateQuery();

  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogIn = useCallback(
    async () => {
      setIsLoggingIn(true);

      try {
        await loginToBlender().unwrap();
        await getAgentState();
      }
      catch {
        /* do nothing */
      }
      finally {
        setIsLoggingIn(false);
      }
    },
    [getAgentState, loginToBlender],
  );

  const handleSwitchAccount = useCallback(
    () => {
      void userManager.signoutRedirect();
    },
    [userManager],
  );

  return (
    <AppBaseLayout
      appContent={
        <CenterContent $backgroundColor={token.colorPrimaryBg} $padding={token.padding}>
          <StyledSpace direction="vertical" size="large" align="center">
            <StyledGraiaIcon />
            <AutoCenter style={{ textAlign: "center" }}>
              <Title level={2}>Welcome</Title>
              <Title level={2}>{`${user.name}!`}</Title>
            </AutoCenter>
            <Button color="primary" loading={isLoggingIn} onClick={() => void handleLogIn()}>Log in to Graia</Button>
          </StyledSpace>
          <ButtonContainer>
            <Button color="primary" fill="none" onClick={handleSwitchAccount}>Switch account</Button>
          </ButtonContainer>
        </CenterContent>
      }
    />
  );
};

export default LoginPage;

const StyledSpace = styled(Space)`
  flex: 1 1 auto;
  justify-content: center;
`;

const ButtonContainer = styled.div`
  flex: 0 0 auto;
  padding: ${p => p.theme.paddingLG}px;
  text-align: center;
  background-color: ${p => p.theme.colorPrimaryBg};
  color: ${p => p.theme.colorPrimary};
`;

const StyledGraiaIcon = styled(GraiaIcon)`
  width: ${p => p.theme.sizeXXL}px;
  height: ${p => p.theme.sizeXXL}px;
  color: ${p => p.theme.colorPrimary};
`;
